var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.94114 156.84643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8- \u0633\u0627\u06CC\u0632 \u0645\u062D\u0635\u0648\u0644") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.02,71.4a2.05114,2.05114,0,0,1-1.03,1.78l-.36.22-16.19,9.58L82.89,96.91a.20847.20847,0,0,0-.06.04,2.06413,2.06413,0,0,1-.54.19995,2.11066,2.11066,0,0,1-1.53-.23L58.51,83.75,40.66,73.18a2.09667,2.09667,0,0,1-.03-3.58L80.74,45.05a2.08569,2.08569,0,0,1,2.18,0l40.1,24.55A2.06566,2.06566,0,0,1,124.02,71.4Z",
    transform: "translate(-0.23917 -1.02777)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.83,96.95a2.06332,2.06332,0,0,1-.54.2",
    transform: "translate(-0.23917 -1.02777)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.83,96.95a2.06332,2.06332,0,0,1-.54.2m3.15,4.06a.09979.09979,0,0,0-.05.04c.02-.01.03-.02.05-.03l36.27-21.48Zm-1.67-1.94a.052.052,0,0,1,.02.04c.1-.07.21-.15.33-.22A2.31228,2.31228,0,0,1,83.77,99.27Z",
    transform: "translate(-0.23917 -1.02777)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.05,150.25v.08a2.06235,2.06235,0,0,1-1.02,1.78,2.03529,2.03529,0,0,1-2.12006.02L37.32,128.59a2.10672,2.10672,0,0,1-1.04-1.77L35.47,80.33a2.09392,2.09392,0,0,1,3.09-1.87l17.47,9.63,22.31,12.29a2.07136,2.07136,0,0,1,1.02,1.38,1.58618,1.58618,0,0,1,.06.38l.02.48a3.42237,3.42237,0,0,0-.02.64Z",
    transform: "translate(-0.23917 -1.02777)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.33,79.5v47.39a2.07532,2.07532,0,0,1-1,1.78l-38.09,23.5a2.08573,2.08573,0,0,1-3.19-1.7l-.01-.29v-.1l-1.6-47.31c-.01-.01,0-.03,0-.04l.95-1.48c.02-.01.03-.02.05-.03l36.27-21.48,3.46-2.04a2.09276,2.09276,0,0,1,3.16,1.8Z",
    transform: "translate(-0.23917 -1.02777)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.5,153.08l-16.65,3.78a3.44342,3.44342,0,0,1-3.73-5.11l4.81-8.12-17.4-10.45-.99-.59,2.57-4.28,1.77,1.06,16.6,9.96,4.75-8.02a3.45033,3.45033,0,0,1,6.29.85l4.54,16.65A3.45756,3.45756,0,0,1,162.5,153.08Z",
    transform: "translate(-0.23917 -1.02777)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.45,133.28,18.3,144.78l5.23,7.71a3.45013,3.45013,0,0,1-3.45,5.33L3.09,154.84a3.44191,3.44191,0,0,1-2.77-4.13l3.66-16.67a3.44037,3.44037,0,0,1,6.21-1.2l5.3,7.8,16.4-10.99,1.41-.95,2.79,4.15Z",
    transform: "translate(-0.23917 -1.02777)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.96,19.96l-9.43.27L84,40.09l.04,1.59-5,.12L79,40.33l-.47-19.95L69.22,20.65A3.438,3.438,0,0,1,66.58,14.89L78.22,2.15a3.44107,3.44107,0,0,1,4.97-.12l12.1,12.05A3.44356,3.44356,0,0,1,92.96,19.96Z",
    transform: "translate(-0.23917 -1.02777)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/Size.071f0ac36c8c2df03a28149b9aa25bbf.svg";
export { ForwardRef as ReactComponent };